import React from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import ProgramApproach from "@/components/landing/ProgramApproach";
import Legacy from "@/components/landing/Legacy";
import Stats from "@/components/landing/Stats";
import ProgramSelection from "@/components/landing/ProgramSelection";
import Recruiters from "@/components/landing/Recruiters";
import FloatingCTA from "@/components/landing/FloatingCTA";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
    return (
        <main data-testid="landing-page" className="min-h-screen bg-white text-slate-900">
            <Header />
            <Hero />
            <ProgramApproach />
            <Legacy />
            <Stats />
            <ProgramSelection />
            <Recruiters />
            <Footer />
            <FloatingCTA />
        </main>
    );
}
